__turbopack_context__.v({
  "className": "manrope_70237e19-module__fgAieq__className",
  "variable": "manrope_70237e19-module__fgAieq__variable",
});
